import { Injectable } from '@angular/core';

import { ComponentStore } from '@ngrx/component-store';

export interface StudyWorkingConditionColorsMap {
  [subCategoryId: string]: {
    [workingConditionId: string]: string;
  };
}

export interface StudyWorkingConditionState {
  colorsMap: StudyWorkingConditionColorsMap;
}

const defaultState: StudyWorkingConditionState = {
  colorsMap: {},
};

@Injectable()
export class StudyWorkingConditionStore extends ComponentStore<StudyWorkingConditionState> {
  constructor() {
    super(defaultState);
  }

  readonly colors$ = this.select(({ colorsMap }) => colorsMap);

  readonly setColors = this.updater((state, colorsMap: StudyWorkingConditionColorsMap) => ({
    ...state,
    colorsMap,
  }));

  readonly getColorsById = (subCategoryId: string, workingConditionId: string) =>
    this.select(state => state.colorsMap[subCategoryId]?.[workingConditionId]);
}
